import { Injectable } from '@angular/core';

export const enum UserStorageKeys {
    UsedThirdPartyApps = 'UsedThirdPartyApps'
}

/**
 * Abstract class defining protocol for roaming user data storage.
 */
@Injectable()
export abstract class UserDataStorageService {
    public abstract get<T>(key: string, remoteAttempts?: number): Promise<T>;
    public abstract set<T>(key: string, value: T): Promise<void>;
    public abstract isFirstUse(): boolean;
    public abstract getFirstUseTimestamp(): number;
}
